import React, { useEffect, useRef } from "react";
import Tablenization from "@icoach/components/Tablenization";
import { Icons, Box, IconButton, Stack, Tooltip } from "@curves/ui-base";
import { LabelHeaderCheckBox, MorePageBox, useLabelCheckBox } from "@icoach/components";
import { useSmartFitnessBandContext } from "@icoach/smartFitnessBand/components/SmartFitnessBandContext";
import { ListInfo } from "@icoach/accountBook/components";
import { rowsLabel } from "@icoach/smartFitnessBand/components/SmartFitnessBandLabel";
import ScrollerArrowButton from "@icoach/inbody/components/ScrollerArrowButton";
import usePrivacyToggle, { securityMaskFilterTypeMap } from "@util/hook/usePrivacyToggle";
import { isEmpty } from "@util/utils";

const SmartFitnessBandOverviewTable = () => {
	const { setBookmarkNum, refresh, dialogRef, setSortTypeParams, reSetCheckedItemsRef, setGetSortByFromTable, bookmark, tableData: list = [], options } = useSmartFitnessBandContext();
	const { totalCount, totalPage, pageIndex, pageSize } = bookmark;
	const { checkBoxsRef, headerCheckBoxRef, onHeaderChange, onCellChange, getCheckedItems, getCheckedSourceData, doSaveCheckedItem, doClearCheckedItems } = useLabelCheckBox();
	const { isRevealed, toggle, renderPrivacyIcon } = usePrivacyToggle();
	const labelTitle = useRef(rowsLabel);
	const listInfoRef = useRef(null);
	const scrollerArrowRef = useRef(null);

	reSetCheckedItemsRef(doClearCheckedItems);

	// 將 ListInfo 的當前排序值提供給 SearchBar 匯出使用
	useEffect(() => {
		setGetSortByFromTable(() => listInfoRef.current?.getResult?.());
	}, [setGetSortByFromTable]);

	// 發送簡訊清空勾選
	const checkedReFresh = () => {
		doClearCheckedItems();
		refresh();
	};

	const handleSortOnChange = value => {
		setSortTypeParams(value);
		refresh();
	};

	const handlePageChange = (e, page) => {
		doSaveCheckedItem();
		setBookmarkNum(page);
		refresh({ pageIndex: page });
	};

	const handleSendSMSClick = () => {
		let params = getCheckedSourceData();
		if (params.length === 0) return;
		params = params.map(target => ({ id: target.memberID, type: 2, name: target.nickName || target.name }));
		dialogRef.current.openSendSmsDialog(params, checkedReFresh);
	};

	const handleToggleRevealed = () => {
		const apiParams = {
			filterType: securityMaskFilterTypeMap.ClubMemberRentCabinet,
			totalCount: list?.length,
		};
		toggle(apiParams);
	};

	return (
		<React.Fragment>
			<Stack className="mb-1 mt-2" alignItems="center" justifyContent="space-between">
				{!isEmpty(list) && (
					<Stack className="all-checkbox-header pb-1">
						<LabelHeaderCheckBox ref={headerCheckBoxRef} onChange={onHeaderChange} />
						<Stack>
							<Tooltip title="群發送簡訊">
								<IconButton onClick={handleSendSMSClick}>
									<Icons.PaperPlane />
								</IconButton>
							</Tooltip>
							{renderPrivacyIcon(handleToggleRevealed, "has-divider")}
						</Stack>
					</Stack>
				)}
				<ListInfo
					ref={listInfoRef}
					onSortOnChange={handleSortOnChange}
					className="ml-auto"
					pageIndex={pageIndex}
					pageSize={pageSize}
					totalCount={totalCount}
					sortDefaultValue={options?.defaultDeviceOrderSortBy || 1}
					sortOptions={options?.deviceSortByOption || []}
					isSort
					isCurrentPageFirstIndex
					isCurrentPageLastIndex
				/>
			</Stack>
			<Box className="scroll-arrow-container">
				<Tablenization cardProps={{ className: "theme-gray overview" }} count={totalPage} page={pageIndex} onChange={handlePageChange} tableContainerRef={scrollerArrowRef} Pagination={MorePageBox} isPagination>
					<Tablenization.TableRowHeader headerRow={labelTitle.current} />
					<Tablenization.TableRowBody
						headerRow={labelTitle.current}
						rowsData={list}
						dialogRef={dialogRef}
						refresh={checkedReFresh}
						checkBoxsRef={checkBoxsRef}
						onCheckBoxChange={onCellChange}
						getCheckedItems={getCheckedItems}
						isRevealed={isRevealed}
					/>
				</Tablenization>
				<ScrollerArrowButton parentRef={scrollerArrowRef} />
			</Box>
		</React.Fragment>
	);
};

export default SmartFitnessBandOverviewTable;
